// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._11q7glyw{background:none}\n._2rko1mok{border-radius:var(--ds-radius-large,8px)}\n._189eidpf{border-width:0}\n._16qsie2t{box-shadow:var(--ds-shadow-overlay,0 8px 9pt rgba(9,30,66,.15),0 0 1px rgba(9,30,66,.31))}\n._1bsby0ve{width:var(--_1rzblqv)}\n._9spsglyw .smart-link-loading-placeholder{display:none}\n._bfhk1bhr{background-color:var(--ds-surface-overlay,#fff)}\n._vchhusvi{box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
